import { render, staticRenderFns } from "./_Chart-radar.vue?vue&type=template&id=35fb4bc9&scoped=true&"
import script from "./_Chart-radar.vue?vue&type=script&lang=js&"
export * from "./_Chart-radar.vue?vue&type=script&lang=js&"
import style0 from "./_Chart-radar.vue?vue&type=style&index=0&id=35fb4bc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb4bc9",
  null
  
)

export default component.exports